import { configureStore } from "@reduxjs/toolkit";

import frontCreditoFilterReducer from "../components/ListCredit/reducer";

export default configureStore({
  reducer: {
    frontCreditoFilters: frontCreditoFilterReducer,
  },
});
